/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconHomeRibbon = createReactComponent("home-ribbon", "IconHomeRibbon", [
  ["path", { d: "M16 15h5v7l-2.5 -1.5l-2.5 1.5z", key: "svg-0" }],
  ["path", { d: "M20 11l-8 -8l-9 9h2v7a2 2 0 0 0 2 2h5", key: "svg-1" }],
  ["path", { d: "M9 21v-6a2 2 0 0 1 2 -2h1.5", key: "svg-2" }]
]);

export { IconHomeRibbon as default };
//# sourceMappingURL=IconHomeRibbon.js.map
